(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection_grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('collectionFilter', ( formEl ) => ({
      form: formEl,
      layout: 'grid',
      init(){
        var layout_cookie = this.getCookie('seyberts_layout');
        if(layout_cookie){
          this.layout = layout_cookie;
        }
      },
      changeLayout(layout = false){
        if(typeof layout === 'string' || layout instanceof String){
          this.layout = layout;
          this.setCookie('seyberts_layout', layout, 365);
        }
      },
      setCookie(cname = false, cvalue = false, exdays = 1) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      },
      getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return false;
      },
      formSubmit(){
        this.form.submit();
      }
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('alpine:init', () => {
    Alpine.data('slideshow', (autoPlay = true, slideTiming = 3000, numOfSlides = 1) => ({
      autoPlay: autoPlay,
      slideTiming:slideTiming,
      numOfSlides:numOfSlides,
      activeSlide: 1,
      timer:null,
      init(){
        if (this.autoPlay){
          this.startTheSlideshow();
        }
      },
      slideInteraction:{
        ['@mouseover'](){
          this.stopTheSlideshow();
        },
        ['@mouseout'](){
          this.startTheSlideshow();
        },
      },
      startTheSlideshow(){
        this.timer = setInterval(()=> { this.nextSlide() }, this.slideTiming);
      },
      stopTheSlideshow(){
        clearInterval(this.timer);
      },
      nextSlide(){
        if(this.activeSlide == this.numOfSlides){
          this.activeSlide = 1;
        } else {
           this.activeSlide++;
        }
      },
      prevSlide(){
        if(this.activeSlide == 1){
          this.activeSlide = this.numOfSlides;
        } else {
           this.activeSlide--;
        }
      },
      goToSlide(id){
        this.activeSlide = id;
      }
    }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product_recommendations"] && !Shopify.designMode) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    var productRecommendationsSection = document.querySelector(".product_recommendations");
    if (productRecommendationsSection === null) { return; }
    var productId = productRecommendationsSection.dataset.productId;
    var limit = productRecommendationsSection.dataset.limit;
    var requestUrl = "/recommendations/products?section_id=product_recommendations&limit="+limit+"&product_id="+productId;
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.innerHTML = container.querySelector(".product_recommendations").innerHTML;
      }
    };
    request.send();
  };
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product_recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
